export const getSearchedContacts = (state) => state.ContactReducer.globalContacts;
export const getPersonalContacts = (state) => state.ContactReducer.personalContacts;
export const getInviterID = (state) => state.ContactReducer.inviterUniqueId;
